import { getRequest } from '../services/requestHandler';
import { SwingWtSuffix } from '../models';

//5537, 3 for testing
export const getSwingWtSuffix = async () => {
  const url = `swingwt/getSwingWtSuffix?activeOnly=true`;
  const response = await getRequest<SwingWtSuffix>('GetSwingWtSuffix', url);
  return response;
};
